import { Box } from "@repo/components/src/ui/box";
import { Heading } from "@repo/components/src/ui/heading";
import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import { VStack } from "@repo/components/src/ui/vstack";
import { LucideIcon } from "lucide-react-native";
import React from "react";

type Props = {
  icon: LucideIcon;
  title: string;
  description: string;
  actions?: React.ReactNode;
};

const EmptyState = React.memo(
  ({ icon, title, description, actions }: Props) => {
    return (
      <Box className="bg-background-50 border border-dashed border-brand-200 rounded-2xl px-8 py-9 items-center">
        <VStack space="md" className="items-center">
          <Box className="w-14 h-14 rounded-2xl bg-white border border-outline-100 items-center justify-center">
            <Icon as={icon} className="text-brand-500" size="lg" />
          </Box>
          <Heading size="sm" className="text-typography-900 text-center">
            {title}
          </Heading>
          <Text size="sm" className="text-typography-500 text-center max-w-md">
            {description}
          </Text>
          {actions ? (
            <HStack space="sm" className="justify-center">
              {actions}
            </HStack>
          ) : null}
        </VStack>
      </Box>
    );
  },
);

EmptyState.displayName = "ReportEmptyState";

export default EmptyState;
